module.exports = __webpack_public_path__ + "img/the-shadowed-sun.88711686.png";